const initialState = {
  resultsList: [],
};

export const resultsReviewReducer = (state = initialState, action) => {
  if (typeof action.execute === "function" && action.type === "resultsReview")
    return action.execute(state);
  return state;
};
